<template>
	<div class="footer">
		<div class="footer-content main-box">
			<p class="copyright">Copyright©2017-2021 版权所有 中国音像与数字出版协会唱片工作委员会 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">京ICP备16008137号</a></p>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Mfooter',
	data() {
		return {}
	}
}
</script>
<style lang="scss" scoped>
.footer {
	.footer-content{
		.copyright{
			font-size: 12px;
			color: #BBBBBB;
			text-align: center;
			height: 50px;
			line-height: 50px;
			a{
				color: #000;
			}
		}
	}
}
</style>